// Internal URLs
export const CONTACT_SUCCESS_URL = '/contact/success'
export const ENGINEERING_URL = '/audio-engineering'
export const EQUIPMENT_URL = '/audio-equipment'
export const TRANSFER_URL = '/audio-transfer'
export const API_NAME = 'backend'
export const CONTACT_ROUTE = '/contact'
export const EVENTS_ROUTE = '/events'

// Contact URLs
export const CONTACT_URL = 'https://tinyurl.com/47d4v6uj'


// Services
export const HOME_SERVICES = [
  'Studio Recording',
  'Live Recording',
  'Mixing',
  'Mastering',
  'Tape Machine Cleaning',
  'Tape Machine Restoration',
  'Tape Machine Calibration',
  'Turntable Setup',
  'Audio Format Transfer',
  'Audio Restoration',
]

export const ENGINEERING_SERVICES = [
  'End-to-End Audio Production',
  'Studio Recording',
  'Live Show & On Location Recording',
  'Overdub Existing Material',
  'Mix Existing Material',
  'Master to CD',
  'Master to LP',
  'Master to Cassette',
  'Master to Hi-Res File',
]

export const EQUIPMENT_SERVICES = [
  'Tape Machine Cleaning',
  'Tape Machine Restoration',
  'Tape Machine Calibration',
  'Turntable Setup',
  'Turntable Cartridge Alignment',
  'Other Audio Equipment Repair',
]

export const TRANSFER_SERVICES = [
  'Tape Baking',
  'LP Transfer',
  'Cassette Transfer',
  'Open Reel Transfer',
  'DTRS Transfer',
  'Other Format Transfer',
]

// External URLs
export const ALEX_PORTFOLIO_URL = 'https://www.alexcharland.com/'
export const GOOGLE_PRIVACY_POLICY = 'https://policies.google.com/privacy'
export const GOOGLE_TERMS = 'https://policies.google.com/terms'

// Section IDs
export const BIO_SECTION_ID = 'BIO_SECTION_ID'
export const SERVICES_SECTION_ID = 'SERVICES_SECTION_ID'

// Redux Actions
export const MARK_HOME_PAGE_AS_VISITED = 'MARK_HOME_PAGE_AS_VISITED'
export const BELOW_SCROLL_THRESHOLD = 'BELOW_SCROLL_THRESHOLD'
export const ABOVE_SCROLL_THRESHOLD = 'ABOVE_SCROLL_THRESHOLD'
export const SET_OFF_HOME_PAGE = 'SET_ON_HOME_PAGE'

// Programmatic CSS
export const SCROLL_CHANGE_THRESHOLD = 20
